import { Location } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import * as RouterActions from '../actions/router.action';
import { isAbsoluteUrl } from '../../utils/utils';
import { of } from 'rxjs';

@Injectable()
export class RouterEffects {
  private actions$ = inject(Actions);
  private router = inject(Router);
  private location = inject(Location);


  navigate$ = createEffect(() => this.actions$.pipe(
    ofType(RouterActions.GO),
    map((action: RouterActions.Go) => action.payload),
    tap(({ path, query: queryParams, extras}) => {
      if (!!path && path.length > 0 && isAbsoluteUrl(path[0])) {
        // not very testable :(
        window.location.href = path[0];
        return of();
      } else {
        return this.router.navigate(path, { queryParams, ...extras });
      }
    })
  ), { dispatch: false });


  navigateToUrl$ = createEffect(() => this.actions$.pipe(
    ofType(RouterActions.GO_TO_URL),
    map((action: RouterActions.GoToUrl) => action.payload),
    tap(({ url, extras}) => {
      if (isAbsoluteUrl(url)) {
        // not very testable :(
        window.location.href = url;
        return of();
      } else {
        return this.router.navigateByUrl(url, { ...extras });
      }
    })
  ), { dispatch: false });


  navigateBack$ = createEffect(() => this.actions$.pipe(
    ofType(RouterActions.BACK),
    tap(() => this.location.back())
  ), { dispatch: false });


  navigateForward$ = createEffect(() => this.actions$.pipe(
    ofType(RouterActions.FORWARD),
    tap(() => this.location.forward())
  ), { dispatch: false });
}
